(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
// =========
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.trans = this.dataset.trans;
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
    this.onScroll();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight) {
      this.header.classList.add('scrolled-past-header');
      if(this.trans != 'false') this.classList.remove('transparent_header');
      document.body.classList.add('sticky-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight) {
      this.header.classList.add('scrolled-past-header');
      if(this.trans != 'false') this.classList.remove('transparent_header');
      document.body.classList.add('sticky-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top || scrollTop < this.header.offsetHeight) {
      this.header.classList.remove('scrolled-past-header');
      if(this.trans != 'false') this.classList.add('transparent_header');
      document.body.classList.remove('sticky-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rannr-product-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!window.customElements || window.customElements.get('rannr-showcase')) return;

  const WL_KEY = 'rannr:wishlist:v1';
  const reducedMotion = () => !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------------- Wishlist ---------------- */
  const LocalWishlist = {
    read() {
      try {
        const v = JSON.parse(window.localStorage.getItem(WL_KEY) || '[]');
        return Array.isArray(v) ? v : [];
      } catch (e) { return []; }
    },
    write(list) {
      try { window.localStorage.setItem(WL_KEY, JSON.stringify(list)); return true; }
      catch (e) { return false; }
    },
    has(id) { return this.read().some((i) => String(i.id) === String(id)); },
    toggle(item) {
      const list = this.read();
      const idx = list.findIndex((i) => String(i.id) === String(item.id));
      let active;
      if (idx > -1) { list.splice(idx, 1); active = false; }
      else { list.push({ id: String(item.id), handle: item.handle, addedAt: Date.now() }); active = true; }
      if (!this.write(list)) throw new Error('storage-unavailable');
      return active;
    }
  };

  const Wishlist = {
    adapter() {
      const a = window.RannrWishlistAdapter;
      return a && typeof a.has === 'function' && typeof a.toggle === 'function' ? a : null;
    },
    has(id) {
      const a = this.adapter();
      try { return a ? !!a.has(String(id)) : LocalWishlist.has(id); } catch (e) { return false; }
    },
    async toggle(item) {
      const a = this.adapter();
      const active = a ? !!(await a.toggle(item)) : LocalWishlist.toggle(item);
      document.dispatchEvent(new CustomEvent('rannr:wishlist:change', { detail: { id: String(item.id), active } }));
      return active;
    }
  };

  /* ---------------- Helpers ---------------- */
  function formatMoney(cents, format) {
    const n = typeof cents === 'string' ? parseInt(cents.replace('.', ''), 10) : cents;
    if (!format) return (n / 100).toFixed(2);
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const delim = (val, precision, thousands, decimal) => {
      if (val == null || isNaN(val)) return '0';
      const parts = (val / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    };
    const m = format.match(re);
    if (!m) return format;
    let out;
    switch (m[1]) {
      case 'amount_no_decimals': out = delim(n, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = delim(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = delim(n, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = delim(n, 2, "'", '.'); break;
      case 'amount_with_space_separator': out = delim(n, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = delim(n, 0, ' ', ','); break;
      default: out = delim(n, 2, ',', '.');
    }
    return format.replace(re, out);
  }

  function cdnUrl(src, width) {
    if (!src) return '';
    let u = String(src);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (width) u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    return u;
  }

  /* ---------------- Slider ---------------- */
  class RsSlider {
    constructor(panel, host) {
      this.panel = panel;
      this.host = host;
      this.track = panel.querySelector('[data-track]');
      if (!this.track) return;
      this.ac = new AbortController();
      const signal = this.ac.signal;
      this.controls = panel.querySelector('[data-controls]');
      this.prev = panel.querySelector('[data-prev]');
      this.next = panel.querySelector('[data-next]');
      this.dotsWrap = panel.querySelector('[data-dots]');
      this.bar = panel.querySelector('[data-progress]');
      this.pages = 0;
      this._raf = 0;

      if (this.prev) this.prev.addEventListener('click', () => this.go(-1), { signal });
      if (this.next) this.next.addEventListener('click', () => this.go(1), { signal });
      if (this.dotsWrap) {
        this.dotsWrap.addEventListener('click', (e) => {
          const dot = e.target.closest('[data-dot]');
          if (dot) this.scrollToX(Number(dot.dataset.dot) * this.step());
        }, { signal });
      }
      this.track.addEventListener('scroll', () => this.schedule(), { signal, passive: true });
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.schedule());
        this.ro.observe(this.track);
      }
      if (host.dataset.drag === 'true') this.bindDrag(signal);
      this.update();
    }

    gap() { return parseFloat(getComputedStyle(this.track).columnGap) || 0; }

    step() {
      const t = this.track;
      const first = t.querySelector('[data-card]');
      if (!first) return t.clientWidth;
      const g = this.gap();
      const col = first.getBoundingClientRect().width + g;
      if (!col) return t.clientWidth;
      const perPage = Math.max(1, Math.floor((t.clientWidth + g) / col + 0.01));
      return perPage * col;
    }

    behavior() { return reducedMotion() ? 'auto' : 'smooth'; }

    scrollToX(x) { this.track.scrollTo({ left: x, behavior: this.behavior() }); }

    go(dir, wrap) {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      if (wrap && dir > 0 && t.scrollLeft >= max - 2) { this.scrollToX(0); return; }
      t.scrollBy({ left: dir * this.step(), behavior: this.behavior() });
    }

    schedule() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => { this._raf = 0; this.update(); });
    }

    update() {
      const t = this.track;
      if (!t || !t.isConnected) return;
      const max = Math.max(0, t.scrollWidth - t.clientWidth);
      const x = Math.min(max, Math.max(0, t.scrollLeft));
      const scrollable = max > 2;
      if (this.controls) this.controls.classList.toggle('is-hidden', !scrollable);
      if (this.prev) this.prev.disabled = x <= 2;
      if (this.next) this.next.disabled = x >= max - 2;

      if (this.bar && t.scrollWidth) {
        const ratio = Math.min(1, t.clientWidth / t.scrollWidth);
        const progress = max ? x / max : 0;
        this.bar.style.width = (ratio * 100) + '%';
        this.bar.style.transform = 'translateX(' + (progress * ((1 / ratio) - 1) * 100) + '%)';
      }

      if (this.dotsWrap) {
        const step = this.step();
        const pages = scrollable && step ? Math.ceil(max / step - 0.01) + 1 : 1;
        if (pages !== this.pages) this.buildDots(pages);
        const active = x >= max - 2 ? pages - 1 : Math.min(pages - 1, Math.round(x / step));
        this.dotsWrap.querySelectorAll('[data-dot]').forEach((d, i) => {
          if (i === active) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }
    }

    buildDots(pages) {
      this.pages = pages;
      this.dotsWrap.replaceChildren();
      if (pages < 2 || pages > 12) { this.dotsWrap.hidden = true; return; }
      this.dotsWrap.hidden = false;
      for (let i = 0; i < pages; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'rannr-showcase__dot';
        b.dataset.dot = String(i);
        b.setAttribute('aria-label', 'Go to page ' + (i + 1) + ' of ' + pages);
        this.dotsWrap.append(b);
      }
    }

    bindDrag(signal) {
      const t = this.track;
      let down = false, moved = false, startX = 0, startLeft = 0, pid = null;
      t.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = t.scrollLeft; pid = e.pointerId;
      }, { signal });
      t.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 6) {
          moved = true;
          t.classList.add('is-dragging');
          try { t.setPointerCapture(pid); } catch (err) { /* noop */ }
        }
        if (moved) t.scrollLeft = startLeft - dx;
      }, { signal });
      const end = () => {
        if (!down) return;
        down = false;
        if (!moved) return;
        t.classList.remove('is-dragging');
        const first = t.querySelector('[data-card]');
        if (first) {
          const col = first.getBoundingClientRect().width + this.gap();
          if (col) this.scrollToX(Math.round(t.scrollLeft / col) * col);
        }
      };
      t.addEventListener('pointerup', end, { signal });
      t.addEventListener('pointercancel', end, { signal });
      t.addEventListener('click', (e) => {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, { capture: true, signal });
      t.addEventListener('dragstart', (e) => e.preventDefault(), { signal });
    }

    destroy() {
      if (this.ac) this.ac.abort();
      if (this.ro) this.ro.disconnect();
      if (this._raf) cancelAnimationFrame(this._raf);
    }
  }

  /* ---------------- Section element ---------------- */
  class RannrShowcase extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.ac = new AbortController();
      const signal = this.ac.signal;

      try { this.cfg = JSON.parse(this.querySelector('[data-rs-config]').textContent); }
      catch (e) { this.cfg = {}; }
      this.S = this.cfg.strings || {};
      this.sid = this.cfg.sectionId || this.id;
      this.root = String(this.cfg.root || '/').replace(/\/?$/, '/');
      this.layout = this.dataset.layout || 'grid';
      this.toastEl = this.querySelector('[data-toast]');
      this.dialog = this.querySelector('[data-qa-dialog]');
      this.sliders = new Map();
      this.productCache = new Map();
      this.motionOK = !reducedMotion() && !(window.Shopify && window.Shopify.designMode);

      if (this.motionOK && 'IntersectionObserver' in window) {
        this.classList.add('rannr-showcase--animate');
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (!en.isIntersecting) return;
            const el = en.target;
            const cards = el.matches('[data-card]') ? [el] : el.querySelectorAll('[data-card]');
            cards.forEach((c) => c.classList.add('is-visible'));
            this.io.unobserve(el);
          });
        }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
      }

      this.addEventListener('click', (e) => this.onClick(e), { signal });
      this.addEventListener('keydown', (e) => this.onKeydown(e), { signal });
      document.addEventListener('rannr:wishlist:change', (e) => this.syncWishlist(e.detail), { signal });
      window.addEventListener('storage', (e) => { if (e.key === WL_KEY) this.refreshWishlist(this); }, { signal });

      if (this.dialog) {
        this.dialog.addEventListener('close', () => this.onDialogClose(), { signal });
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); }, { signal });
        this.dialog.addEventListener('change', (e) => { if (e.target.matches('.rannr-qa__input')) this.updateQa(); }, { signal });
        const form = this.dialog.querySelector('[data-qa-form]');
        if (form) form.addEventListener('submit', (e) => this.onQaSubmit(e), { signal });
      }

      if (this.dataset.autoplay === 'true') {
        const pause = () => { this._paused = true; };
        const resume = () => { this._paused = false; };
        this.addEventListener('pointerenter', pause, { signal });
        this.addEventListener('pointerleave', resume, { signal });
        this.addEventListener('focusin', pause, { signal });
        this.addEventListener('focusout', resume, { signal });
      }

      const active = this.querySelector('[data-panel]:not([hidden])');
      if (active) this.initPanel(active, false);
      this.startAutoplay();
    }

    disconnectedCallback() {
      if (this.ac) this.ac.abort();
      if (this.io) this.io.disconnect();
      this.sliders.forEach((s) => s.destroy());
      this.sliders.clear();
      this.stopAutoplay();
      clearTimeout(this._toastT);
      clearTimeout(this._tabT);
      this._ready = false;
    }

    initPanel(panel, reveal) {
      if (panel._rsInit) return;
      panel._rsInit = true;
      this.refreshWishlist(panel);
      const cards = panel.querySelectorAll('[data-card]');
      if (this.io && !reveal) {
        if (this.layout === 'grid') {
          cards.forEach((c, i) => { c.style.setProperty('--i', String(i % 4)); this.io.observe(c); });
        } else {
          const track = panel.querySelector('[data-track]');
          cards.forEach((c, i) => c.style.setProperty('--i', String(Math.min(i, 6))));
          if (track) this.io.observe(track);
        }
      } else {
        cards.forEach((c) => c.classList.add('is-visible'));
      }
      if (this.layout !== 'grid') this.sliders.set(panel, new RsSlider(panel, this));
    }

    /* ---- Events ---- */
    onClick(e) {
      const t = e.target.closest('[data-wishlist],[data-swatch],[data-quick-add],[data-tab],[data-qa-close]');
      if (!t || !this.contains(t)) return;
      if (t.hasAttribute('data-wishlist')) { e.preventDefault(); this.toggleWishlist(t); }
      else if (t.hasAttribute('data-swatch')) { e.preventDefault(); this.selectSwatch(t); }
      else if (t.hasAttribute('data-quick-add')) { e.preventDefault(); this.onQuickAdd(t); }
      else if (t.hasAttribute('data-tab')) { this.selectTab(t, false); }
      else if (t.hasAttribute('data-qa-close')) { this.dialog && this.dialog.close(); }
    }

    onKeydown(e) {
      const tab = e.target.closest && e.target.closest('[data-tab]');
      if (!tab) return;
      const tabs = Array.from(this.querySelectorAll('[data-tab]'));
      const i = tabs.indexOf(tab);
      let n = null;
      switch (e.key) {
        case 'ArrowRight': n = tabs[(i + 1) % tabs.length]; break;
        case 'ArrowLeft': n = tabs[(i - 1 + tabs.length) % tabs.length]; break;
        case 'Home': n = tabs[0]; break;
        case 'End': n = tabs[tabs.length - 1]; break;
        default: return;
      }
      e.preventDefault();
      this.selectTab(n, true);
    }

    /* ---- Tabs ---- */
    selectTab(tab, focus) {
      if (focus) tab.focus();
      if (tab.getAttribute('aria-selected') === 'true') return;
      this.querySelectorAll('[data-tab]').forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      const next = document.getElementById(tab.getAttribute('aria-controls'));
      if (!next || !this.contains(next)) return;
      const current = this.querySelector('[data-panel]:not([hidden])');
      const tpl = next.querySelector(':scope > template[data-panel-template]');
      if (tpl) { next.appendChild(tpl.content.cloneNode(true)); tpl.remove(); }
      const wrap = this.querySelector('[data-panels]');

      const swap = () => {
        this.querySelectorAll('[data-panel]').forEach((p) => {
          if (p !== next) { p.hidden = true; p.classList.remove('is-fading'); }
        });
        next.hidden = false;
        this.initPanel(next, true);
        const slider = this.sliders.get(next);
        if (slider) slider.update();
        void next.offsetWidth;
        next.classList.remove('is-fading');
        this.startAutoplay();
        setTimeout(() => { if (wrap) wrap.style.minHeight = ''; }, 240);
      };

      clearTimeout(this._tabT);
      if (!this.motionOK || !current || current === next) { next.classList.remove('is-fading'); swap(); return; }
      if (wrap) wrap.style.minHeight = wrap.offsetHeight + 'px';
      next.classList.add('is-fading');
      current.classList.add('is-fading');
      this._tabT = setTimeout(swap, 200);
    }

    /* ---- Autoplay ---- */
    startAutoplay() {
      this.stopAutoplay();
      if (this.dataset.autoplay !== 'true' || !this.motionOK || this.layout === 'grid') return;
      const ms = Math.max(3, Number(this.dataset.autoplaySpeed) || 5) * 1000;
      this._ap = setInterval(() => {
        if (this._paused || document.hidden) return;
        if (this.dialog && this.dialog.open) return;
        const panel = this.querySelector('[data-panel]:not([hidden])');
        const s = panel && this.sliders.get(panel);
        if (s) s.go(1, true);
      }, ms);
    }

    stopAutoplay() { if (this._ap) { clearInterval(this._ap); this._ap = null; } }

    /* ---- Wishlist ---- */
    setWishState(btn, active) {
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      const label = active ? btn.dataset.labelRemove : btn.dataset.labelAdd;
      if (label) btn.setAttribute('aria-label', label);
    }

    refreshWishlist(scope) {
      scope.querySelectorAll('[data-wishlist]').forEach((b) => this.setWishState(b, Wishlist.has(b.dataset.productId)));
    }

    syncWishlist(detail) {
      if (!detail) return;
      this.querySelectorAll('[data-wishlist]').forEach((b) => {
        if (String(b.dataset.productId) === String(detail.id)) this.setWishState(b, !!detail.active);
      });
    }

    async toggleWishlist(btn) {
      if (btn._busy) return;
      btn._busy = true;
      const prev = btn.getAttribute('aria-pressed') === 'true';
      const title = btn.dataset.title || '';
      this.setWishState(btn, !prev);
      btn.classList.remove('is-popping');
      void btn.offsetWidth;
      btn.classList.add('is-popping');
      try {
        const active = await Wishlist.toggle({ id: btn.dataset.productId, handle: btn.dataset.handle, title });
        this.setWishState(btn, active);
        this.showToast(title + ' ' + (active ? this.S.wishAdded : this.S.wishRemoved));
      } catch (err) {
        this.setWishState(btn, prev);
        this.showToast(this.S.wishError, true);
      } finally {
        btn._busy = false;
        setTimeout(() => btn.classList.remove('is-popping'), 400);
      }
    }

    /* ---- Swatches ---- */
    selectSwatch(btn) {
      const card = btn.closest('[data-card]');
      if (!card) return;
      card.querySelectorAll('[data-swatch]').forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
      card.dataset.variantId = btn.dataset.variantId;
      card.dataset.available = btn.dataset.available;

      const link = card.querySelector('[data-card-link]');
      if (link && card.dataset.url) link.href = card.dataset.url + '?variant=' + encodeURIComponent(btn.dataset.variantId);

      const desc = card.querySelector('[data-desc-color]');
      if (desc && btn.dataset.value) desc.textContent = btn.dataset.value;

      const wishApp = card.querySelector('.wishlist-engine');
      if (wishApp) wishApp.setAttribute('data-variant_id', btn.dataset.variantId);

      const img = card.querySelector('.rannr-card__img');
      const src = btn.dataset.src;
      if (img && src && img.currentSrc !== src && img.getAttribute('src') !== src) {
        const pre = new Image();
        if (img.sizes) pre.sizes = img.sizes;
        if (btn.dataset.srcset) pre.srcset = btn.dataset.srcset;
        pre.src = src;
        const apply = () => {
          if (btn.getAttribute('aria-pressed') !== 'true') return;
          img.srcset = btn.dataset.srcset || '';
          img.src = src;
          if (btn.dataset.alt) img.alt = btn.dataset.alt;
        };
        (pre.decode ? pre.decode() : Promise.resolve()).then(apply, apply);
      }
    }

    /* ---- Quick add ---- */
    onQuickAdd(btn) {
      const card = btn.closest('[data-card]');
      if (!card || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      if (card.dataset.direct === 'true') this.quickAddDirect(btn, card);
      else this.openQuickAdd(btn, card);
    }

    async quickAddDirect(btn, card) {
      if (card.dataset.available !== 'true') { this.showToast(this.S.soldOut, true); return; }
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      try {
        await this.addToCart(card.dataset.variantId, { title: card.dataset.title });
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1600);
      } catch (err) {
        this.showToast(err.message || this.S.addError, true);
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    }

    async openQuickAdd(btn, card) {
      if (!this.dialog || typeof this.dialog.showModal !== 'function') { window.location.assign(card.dataset.url); return; }
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      try {
        const handle = card.dataset.handle;
        let product = this.productCache.get(handle);
        if (!product) {
          const res = await fetch(this.root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
          if (!res.ok) throw new Error('product-fetch');
          product = await res.json();
          this.productCache.set(handle, product);
        }
        this.qaProduct = product;
        this.qaTrigger = btn;
        this.renderQa(product, card);
        this.dialog.showModal();
      } catch (err) {
        window.location.assign(card.dataset.url);
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    }

    normalizeOptions(product) {
      return (product.options || []).map((o, i) => {
        if (typeof o === 'string') {
          const values = [];
          product.variants.forEach((v) => { const x = v.options[i]; if (values.indexOf(x) === -1) values.push(x); });
          return { name: o, values };
        }
        return { name: o.name, values: o.values || [] };
      });
    }

    renderQa(product, card) {
      const d = this.dialog;
      const opts = this.normalizeOptions(product);
      this.qaOpts = opts;
      const preferred = String(card.dataset.variantId || '');
      const initial =
        product.variants.find((v) => String(v.id) === preferred) ||
        product.variants.find((v) => v.available) ||
        product.variants[0];

      d.querySelector('[data-qa-title]').textContent = product.title;
      const label = card.querySelector('.rannr-card__label');
      d.querySelector('[data-qa-label]').textContent = label ? label.textContent : '';
      const link = d.querySelector('[data-qa-link]');
      if (link) link.href = card.dataset.url;
      const err = d.querySelector('[data-qa-error]');
      if (err) { err.hidden = true; err.textContent = ''; }

      const wrap = d.querySelector('[data-qa-options]');
      wrap.replaceChildren();
      opts.forEach((opt, i) => {
        const fs = document.createElement('fieldset');
        fs.className = 'rannr-qa__option';
        const lg = document.createElement('legend');
        lg.textContent = opt.name;
        const vals = document.createElement('div');
        vals.className = 'rannr-qa__values';
        opt.values.forEach((val, vi) => {
          const id = 'RannrQa-' + this.sid + '-' + i + '-' + vi;
          const input = document.createElement('input');
          input.type = 'radio';
          input.className = 'rannr-qa__input';
          input.name = 'rannr-qa-' + this.sid + '-' + i;
          input.id = id;
          input.value = val;
          input.dataset.index = String(i);
          input.checked = initial ? initial.options[i] === val : vi === 0;
          const lab = document.createElement('label');
          lab.className = 'rannr-qa__value';
          lab.htmlFor = id;
          lab.textContent = val;
          vals.append(input, lab);
        });
        fs.append(lg, vals);
        wrap.append(fs);
      });
      this.updateQa();
    }

    updateQa() {
      const p = this.qaProduct;
      const d = this.dialog;
      if (!p || !d) return;
      const sel = this.qaOpts.map((_, i) => {
        const c = d.querySelector('input[name="rannr-qa-' + this.sid + '-' + i + '"]:checked');
        return c ? c.value : null;
      });
      const variant = p.variants.find((v) => v.options.every((o, i) => o === sel[i])) || null;
      this.qaVariant = variant;

      d.querySelectorAll('.rannr-qa__input').forEach((inp) => {
        const i = Number(inp.dataset.index);
        const ok = p.variants.some((v) => v.available && v.options[i] === inp.value &&
          v.options.every((o, j) => j === i || sel[j] == null || o === sel[j]));
        inp.nextElementSibling.classList.toggle('is-unavailable', !ok);
      });

      const fmt = this.cfg.moneyFormat;
      const priceEl = d.querySelector('[data-qa-price]');
      priceEl.replaceChildren();
      const cur = document.createElement('span');
      cur.textContent = formatMoney(variant ? variant.price : p.price, fmt);
      priceEl.append(cur);
      if (variant && variant.compare_at_price > variant.price) {
        const s = document.createElement('s');
        s.textContent = formatMoney(variant.compare_at_price, fmt);
        priceEl.append(' ', s);
      }

      const img = d.querySelector('[data-qa-img]');
      const fi = variant && variant.featured_image;
      const src = (fi && fi.src) || p.featured_image;
      if (img && src) {
        img.src = cdnUrl(src, 720);
        img.alt = (fi && fi.alt) || p.title;
      }

      const btn = d.querySelector('[data-qa-submit]');
      if (!this._qaBusy) {
        btn.disabled = !variant || !variant.available;
        btn.textContent = !variant ? this.S.unavailable : (variant.available ? this.S.addToCart : this.S.soldOut);
      }
    }

    async onQaSubmit(e) {
      e.preventDefault();
      const v = this.qaVariant;
      if (!v || !v.available || this._qaBusy) return;
      const btn = this.dialog.querySelector('[data-qa-submit]');
      const err = this.dialog.querySelector('[data-qa-error]');
      this._qaBusy = true;
      btn.disabled = true;
      btn.textContent = this.S.adding;
      btn.setAttribute('aria-busy', 'true');
      err.hidden = true;
      try {
        await this.addToCart(v.id, { title: this.qaProduct.title, before: () => this.dialog.close() });
      } catch (ex) {
        err.textContent = ex.message || this.S.addError;
        err.hidden = false;
      } finally {
        this._qaBusy = false;
        btn.removeAttribute('aria-busy');
        this.updateQa();
      }
    }

    onDialogClose() {
      if (this.qaTrigger && this.qaTrigger.isConnected) this.qaTrigger.focus({ preventScroll: true });
    }

    /* ---- Cart ---- */
    async addToCart(variantId, opts) {
      opts = opts || {};
      const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      let sections = [];
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        try { sections = drawer.getSectionsToRender().map((s) => s.id); } catch (e) { sections = []; }
      }
      const body = { id: Number(variantId), quantity: 1 };
      if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }

      let res, data;
      try {
        res = await fetch(this.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        });
        data = await res.json();
      } catch (e) {
        throw new Error(this.S.addError);
      }
      if (!res.ok || data.status) throw new Error(data.description || data.message || this.S.addError);

      if (typeof opts.before === 'function') opts.before();

      let handled = false;
      if (drawer && data.sections && typeof drawer.renderContents === 'function') {
        try {
          drawer.renderContents(data);
          drawer.classList.remove('is-empty');
          handled = true;
        } catch (e) {
          console.warn('[rannr-showcase] Theme cart UI refresh failed', e);
        }
      }

      try {
        /* global publish, PUB_SUB_EVENTS */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rannr-showcase', productVariantId: Number(variantId), cartData: data });
        }
      } catch (e) { /* theme pub/sub absent */ }

      if (!handled) {
        await this.refreshCartBubble();
        this.showToast((opts.title ? opts.title + ' ' : '') + this.S.added, false, { href: this.cfg.cartUrl || '/cart', label: this.S.viewCart });
      }

      document.dispatchEvent(new CustomEvent('rannr:cart:added', { detail: { variantId: Number(variantId), item: data } }));
      return data;
    }

    async refreshCartBubble() {
      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      try {
        const r = await fetch(this.root + '?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } });
        if (!r.ok) return;
        const j = await r.json();
        const html = j && j['cart-icon-bubble'];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const src = doc.querySelector('.shopify-section') || doc.body;
        bubble.innerHTML = src.innerHTML;
      } catch (e) { /* non-critical */ }
    }

    /* ---- Toast ---- */
    showToast(msg, isError, action) {
      const t = this.toastEl;
      if (!t) return;
      t.replaceChildren();
      const span = document.createElement('span');
      span.textContent = msg;
      t.append(span);
      if (action && action.href) {
        const a = document.createElement('a');
        a.href = action.href;
        a.textContent = action.label;
        t.append(a);
      }
      t.classList.toggle('is-error', !!isError);
      t.classList.add('is-visible');
      clearTimeout(this._toastT);
      this._toastT = setTimeout(() => t.classList.remove('is-visible'), action ? 5000 : 2600);
    }
  }

  window.customElements.define('rannr-showcase', RannrShowcase);
})();

  } catch(e) { console.error(e); }
})();
})();
